<appshell-main analyticsLogUserTraits>
    <analytics-dynamic-component-holder />
</appshell-main>
